import { useEffect, useState } from 'react'
import { EMAIL_REGEX } from '@aytm/app/lib/regex'
import { SsoProviderData } from '../types'
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'

const SSO_DETECT_DELAY_MS = 400

export function useSsoDetect(email: string, detectProviderPath: string) {
  const [sso, setSso] = useState<SsoProviderData | null>(null)

  useEffect(() => {
    if (!EMAIL_REGEX.test(email)) {
      setSso(null)
      return
    }

    // Stale-response guard: a probe dispatched for an earlier email value must not
    // overwrite the branding once the email has changed. The cleanup flips `active`
    // off, so a late response for a superseded value is ignored (GAP-023).
    let active = true

    const timeout = setTimeout(() => {
      const fetchSsoProvider = async () => {
        const response = await railsPostFetch(detectProviderPath, {
          body: JSON.stringify({ email })
        })
        const data = await response.json()
        return data?.headerText ? (data as SsoProviderData) : null
      }

      fetchSsoProvider()
        .then(data => {
          if (active) setSso(data)
        })
        .catch(() => {
          if (active) setSso(null)
        })
    }, SSO_DETECT_DELAY_MS)

    return () => {
      active = false
      clearTimeout(timeout)
    }
  }, [email, detectProviderPath])

  return sso
}
